import request from '@/utils/request'

// 门店操作日志
export function saveCustomerServiceOperationLog(data) {
    return request({
        url: `/customer-service-operation-log/saveCustomerServiceOperationLog`,
        method: 'POST',
        data: data
    })
}
export function customerServiceOnLine() {
    return request({
        url: `customer-service/customerServiceOnLine`,
        method: 'POST',
    })
}

export function detailCustomerService(customerServiceId) {
    return request({
        url: `/customer-service/detailCustomerService?customerServiceId=${customerServiceId}`,
        method: 'get',
    })
}

export function currentCustomerService() {
    return request({
        url: `/customer-service/currentCustomerService`,
        method: 'get',
    })
}

export function updateServiceStatus(serviceStatus) {
    return request({
        url: `/customer-service/updateServiceStatus`,
        method: 'post',
        data: {
            serviceStatus
        }
    })
}

// 重置token
export function clearAccessToken() {
    return request({
        url: `/camera-device/clearAccessToken`,
        method: 'post',
    })
}